import { useState } from "react";
import { Box, Button, Grid, Link, Breadcrumbs, Tooltip, Typography, TextField, TextareaAutosize } from "@mui/material";
import { axios } from "utilities";
import { FormSubsection, DisplayField, MUITableD } from "components";
import { useTranslation } from "react-i18next";

type Props = {
  data: any;
};

const MessageTrace = (props: Props) => {
  const { data } = props;
  const { t } = useTranslation("telemetry"); // Get translation
  const [payload, setPayload] = useState("")

  const cT = data ? data : {};

  const handleRowClick = () => { };

  const handleLoadFile = (key: String) => {
    axios({
      method: "post",
      data: { key1: key },
      url: "/api/vvr/monitor/file",
    }).then((res) => {
      setPayload(res.data)
    }).catch((reason) => {
      console.log(reason);
    });
  }

  const columns = [
    { name: "destinationName", label: t("Name") },
    { name: "deliveryStatus", label: t("Status") },
    { name: "deliveryDateTime", label: t("Timestamp") },
    { name: "deliveryFailureReason", label: t("Failure Reason") },
    { name: "lastFailureAt", label: t("Last Failure At") },
    { name: "responseStatusCode", label: t("HTTP Status") },
    { name: "configurationPath", label: t("Path") },
  ];

  const modalStyle = {
    position: 'absolute',
    overflow: 'scroll',
    height: '100%',
    display: 'block',
    left: '10%',
    right: '10%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>

      {/* Fixed Header */}
      <Box sx={modalStyle}>
        <FormSubsection title={t("Message Trace")}>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <DisplayField
                data={cT}
                name="deviceId"
                label={t("Device ID")}
              />
            </Grid>
            <Grid item xs={4}>
              <DisplayField
                data={cT}
                name="receivedAt"
                label={t("Received At")}
              />
            </Grid>
            <Grid item xs={2}>
              <DisplayField
                data={cT}
                name="processingStatus"
                label={t("Processing")}
              />
            </Grid>
            <Grid item xs={2}>
              <DisplayField
                data={cT}
                name="deliveryStatus"
                label={t("Delivery")}
              />
            </Grid>
            <Grid item xs={2}>
              <DisplayField
                data={cT}
                name="clnt"
                label={t("Client")}
              />
            </Grid>
            <Grid item xs={2}>
              <DisplayField
                data={cT}
                name="sorg"
                label={t("Sales Org")}
              />
            </Grid>
            <Grid item xs={4}>
              <DisplayField
                data={cT}
                name="processingType"
                label={t("Processing Type")}
              />
            </Grid>
            <Grid item xs={12}>
              <DisplayField
                data={cT}
                name="s3Key"
                label={t("Payload Storage Path")}
              />
            </Grid>
          </Grid>
        </FormSubsection>

        <FormSubsection title={t("VDI Data")}>
          <Grid container spacing={3}>
            <Grid item xs={2}>
              <DisplayField
                data={cT.soapMetadata}
                name="applicationId"
                label={t("Application ID")}
              />
            </Grid>
            <Grid item xs={2}>
              <DisplayField
                data={cT.soapMetadata}
                name="applicationVersion"
                label={t("Application Version")}
              />
            </Grid>
            <Grid item xs={2}>
              <DisplayField
                data={cT.soapMetadata}
                name="customerId"
                label={t("Customer ID")}
              />
            </Grid>
            <Grid item xs={2}>
              <DisplayField
                data={cT.soapMetadata}
                name="providerId"
                label={t("Provider ID")}
              />
            </Grid>
            <Grid item xs={2}>
              <DisplayField
                data={cT.soapMetadata}
                name="vdiXmlVersion"
                label={t("VDI Version")}
              />
            </Grid>
          </Grid>
        </FormSubsection>

        <FormSubsection title={t("DEX Data")}>
          <Grid container spacing={3}>
            <Grid item xs={2}>
              <DisplayField
                data={cT.dexMetadata}
                name="dexReason"
                label={t("Reason")}
              />
            </Grid>
            <Grid item xs={2}>
              <DisplayField
                data={cT.dexMetadata}
                name="responseCode"
                label={t("Response")}
              />
            </Grid>
            <Grid item xs={4}>
              <DisplayField
                data={cT.dexMetadata}
                name="transactionId"
                label={t("Transaction ID")}
              />
            </Grid>
            <Grid item xs={2}>
              <DisplayField
                data={cT.dexMetadata}
                name="fileSize"
                label={t("File Size")}
              />
            </Grid>
            <Grid item xs={2}>
              <DisplayField
                data={cT.dexMetadata}
                name="dexType"
                label={t("Type")}
              />
            </Grid>
          </Grid>
        </FormSubsection>

        {data.destinationDelivery &&
          data.destinationDelivery.length > 0 && (
            <FormSubsection title={t("Destinations")}>
              <MUITableD
                title=""
                data={data.destinationDelivery}
                cols={columns}
                sortOrder={{ name: "destinationName", direction: "asc" }}
                onRowClick={handleRowClick}
              />
            </FormSubsection>
          )}
        {(payload.length === 0)
          ?
          <Link
            component="button"
            variant="body2"
            onClick={() => {
              handleLoadFile(cT.s3Key);
            }}
          >
            Display Message Payload
          </Link>
          :
          <TextareaAutosize value={payload} name="payload" disabled={true} style={{ width: '100%' }} minRows={100} />

        }


      </Box>

    </>
  );
};

export default MessageTrace;
